import React from "react";
import { useModal } from "../../Components/ModalContext/ModalContext";
import "./NetworkErrorModal.css";
import { useNavigate } from "react-router-dom";

export default function NetworkErrorModal() {
    const { modalData, closeModal } = useModal();
    const navigate = useNavigate()
    if (!modalData.open) return null;
      const refresh = () => {
    window.location.href = '/';
    navigate('/');
  };
    const closeTab = () => {
        closeModal()
        localStorage.clear();
        navigate("/");
        refresh();
    }
    return (
        <div className="modal-overlay">
            <div className="modal-box">
                <h2 className="modal-title"><span >Network Error</span></h2>
                <p className="modal-message">{modalData.message}</p>
                <button onClick={() => closeTab()} className="modal-button">
                    OK
                </button>
            </div>
        </div>
    );
}

